import type { Unit } from '../types/unit';
import type { WeaponData } from '../types/weapon';
import { getWeaponsForUnit } from './unit-weapons';

type WeaponsData = { [descriptorName: string]: { descriptorName: string; hasDefensiveSmoke: boolean; weapons: WeaponData[] } };

/**
 * Find all units that use a specific ammo type
 * @param ammoDescriptorName The descriptor name of the ammo to search for
 * @param units Array of all units, or null if not loaded
 * @param weaponsData Weapons data object, or null if not loaded
 * @returns Array of units that use the specified ammo
 */
export function getUnitsUsingAmmo(
  ammoDescriptorName: string,
  units: Unit[] | null,
  weaponsData: WeaponsData | null
): Unit[] {
  if (!units || !weaponsData || !ammoDescriptorName) {
    return [];
  }

  const matchingUnits: Unit[] = [];

  for (const unit of units) {
    const weapons = getWeaponsForUnit(unit, weaponsData);
    
    // Check if any weapon uses this ammo
    const usesAmmo = weapons.some((weapon) => {
      // Check if the weapon's ammo descriptor matches
      if (weapon.ammo.descriptorName === ammoDescriptorName) {
        return true;
      }
      
      // Also check ammoDescriptors array if present (for merged weapons)
      if (weapon.ammoDescriptors && weapon.ammoDescriptors.includes(ammoDescriptorName)) {
        return true;
      }
      
      return false;
    });

    if (usesAmmo) {
      matchingUnits.push(unit);
    }
  }

  return matchingUnits;
}

